import styled from 'styled-components';

export const Table = styled.table`
  border-collapse: collapse;
  border: 1px solid #d1d1d1;

  background: #fff;
  & > thead th {
    height: 35px;
    text-align: center;
    background: #fafafa;
    border-bottom: 1px solid #d1d1d1;
  }

  & > tbody > tr > td {
    max-height: 154px;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const SubTable = styled.table`
  border-collapse: collapse;

  background: #fff;

  & > tbody tr:not(:last-child) {
    border-bottom: 1px solid rgb(236, 239, 243);
  }

  & > tbody td {
    height: 34px;
    text-align: center;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const DownIcon = styled.span`
  display: inline-block;
  content: '';
  width: 0;
  height: 0;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  border-top: 4px solid #2a83ff;
  border-bottom: 4px solid transparent;
  margin-left: 8px;
  vertical-align: middle;
`;

export const UpIcon = styled.span`
  display: inline-block;
  content: '';
  width: 0;
  height: 0;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  border-top: 4px solid transparent;
  border-bottom: 4px solid #ed2026;
  margin-left: 8px;
  vertical-align: middle;
`;
